export default __webpack_public_path__ + "static/media/footer.7975d9a1.png";